import { SelectField } from '@/components';
import {
  type ProjectSearchFormType,
  conditionTypeEnum,
  conditionTypeLabelModifier,
} from '@/features/search/_models/projects-search';
import type { AmountSearchConditionFieldName } from '@/features/search/_utils/project-amount-search';
import { resetAnalyticTrendFields } from '@/features/search/_utils/projects-search';
import { type FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const options = conditionTypeEnum.options.map((value) => ({
  value,
  label: conditionTypeLabelModifier[value],
}));

type Props = {
  name: AmountSearchConditionFieldName<'conditionType'>;
  hint: string;
  index: number;
};

export const AmountSearchTypeField: FC<Props> = memo(
  ({ name, hint, index }) => {
    const { t } = useTranslation();
    const { control, setValue } = useFormContext<ProjectSearchFormType>();

    return (
      <SelectField
        name={name}
        label={t('amount-search-type')}
        hint={hint}
        control={control}
        options={options}
        allowClear={false}
        // card単位でハンドリングするためここでerrorを空にする
        errors={{}}
        shouldCoexistOnChange
        onChange={() => {
          resetAnalyticTrendFields({
            setValue,
            index,
          });
        }}
        wrapperStyle={{ marginBottom: 0 }}
        width={120}
      />
    );
  },
);
